export const AdminDashApiUrls = {
  getCompanyCredits: "dash/GetCompanyCredits",
  getCompanyStatistics: "dash/GetCompanyStatistics",
  getFinishedAppsBetweenDates: "dash/GetFinishedAppsBetweenDates",
  getSentAppsBetweenDates: "dash/GetSentAppsBetweenDates",
};

export default class adminDashAPI {
  constructor(httpsClient, cache) {
    this.httpsClient = httpsClient;
    this.cache = cache;
  }

  async getCompanyCredits(data, token) {
    return this.get(AdminDashApiUrls.getCompanyCredits, data, token);
  }

  async getCompanyStatistics(data, token) {
    return this.get(AdminDashApiUrls.getCompanyStatistics, data, token);
  }

  async getSentAppsBetweenDates(data, token) {
    return this.get(AdminDashApiUrls.getSentAppsBetweenDates, data, token);
  }

  async getFinishedAppsBetweenDates(data, token) {
    return this.get(AdminDashApiUrls.getFinishedAppsBetweenDates, data, token);
  }

  async get(url, data, token, eAlert, sAlert) {
    return await this.httpsClient.get(url, data, token, eAlert, sAlert);
  }

  async post(url, data, token, eAlert, sAlert) {
    this.cache.remove("tests");

    return await this.httpsClient.post(url, data, token, eAlert, sAlert);
  }
}
